var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { container } from 'tsyringe';
import { IntercomManager } from 'packages/intercom/IntercomManager';
import env from 'config/env';
import { FeatureToggleService } from '@jobilla/feature-toggles';
import { registerQuillBlots } from 'packages/core/DeltaRenderer';
import { extend } from 'vee-validate';
import { JobListRepository } from 'packages/job_lists/JobListRepository';
import ValidationService from 'services/ValidationService';
import * as rules from 'vee-validate/dist/rules';
var JobillaApplication = /** @class */ (function () {
    function JobillaApplication() {
        this.features = container.resolve(FeatureToggleService);
    }
    JobillaApplication.prototype.boot = function (options) {
        if (options.withIntercom) {
            this.bootIntercom();
        }
        registerQuillBlots(options.quillScope);
        this.registerCustomValidationRules();
    };
    JobillaApplication.prototype.bootIntercom = function () {
        var intercomCredentials = {
            app_id: env.INTERCOM_API_KEY,
        };
        container.register('IIntercomCredentials', {
            useValue: intercomCredentials,
        });
        var intercomManager = container.resolve(IntercomManager);
        intercomManager.createInstaller(intercomCredentials).boot(intercomCredentials);
    };
    JobillaApplication.prototype.registerCustomValidationRules = function () {
        var _this = this;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        extend('domain', function (value, _a) {
            var excluded = _a[0];
            return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_b) {
                    // consumers can pass an excluded subdomain (usually the currently active one for the resource)
                    // to skip checks if the domain matches that value.
                    if (excluded && value === excluded) {
                        return [2 /*return*/, true];
                    }
                    // custom domains are not allowed to use a jobilla domain, with any TLD.
                    if (value.toLowerCase().match(/jobilla\.[a-z]+$/) !== null) {
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/, container.resolve(JobListRepository).checkDomain(value)];
                });
            });
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        extend('subdomain', function (value, _a) {
            var excluded = _a[0];
            return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_b) {
                    // consumers can pass an excluded subdomain (usually the currently active one for the resource)
                    // to skip checks if the domain matches that value.
                    if (excluded && value === excluded) {
                        return [2 /*return*/, true];
                    }
                    return [2 /*return*/, container.resolve(JobListRepository).checkDomain(value, true)];
                });
            });
        });
        var validationService = container.resolve(ValidationService);
        extend('url', function (value) { return validationService.isUrl(value); });
        extend('url_no_protocol', function (value) { return validationService.isUrl(value, false); });
        extend('phone', function (value) { return validationService.isPhoneNumber(value); });
        Object.keys(rules).forEach(function (rule) {
            // As vee-validate 3 auto infers max and min values, if was causing weird conflicts with JDS validation
            if (rule === 'max_value' || rule === 'min_value') {
                return;
            }
            extend(rule, rules[rule]);
        });
    };
    return JobillaApplication;
}());
export { JobillaApplication };
